/* eslint-disable react/destructuring-assignment */
import React, { FC, Fragment } from 'react';
import { Hero, SectionComponent } from 'components';
import { ExperienceCardListing } from '../../components/ExperienceCardListing';

interface Props {
	components: any;
}

export const ExperienceTempPage: FC<Props> = props => {
	const [experiences] = React.useState(props.components.find(p => p.componentName === 'experience-listing'));
	const [hero] = React.useState(props.components.find(p => p.componentName === 'hero'));
	const [section] = React.useState(props.components.find(p => p.componentName === 'section-component'));

	return (
		<Fragment>
			{hero && <Hero {...hero} />}
			{experiences && <ExperienceCardListing experienceCards={experiences.experienceCards} />}
			{section && <SectionComponent {...section} />}
		</Fragment>
	);
};
